import './login.scss'
import logo from 'assets/img/logo.png';
import { Button, Form, Input } from 'antd';
import { useCallback, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducerType } from 'model/reducers/RootReducerType';
import { loginRequestAction } from 'domain/actions/auth/auth.action';
import { useQuery } from 'utils/useQuery';
import UrlConfig from 'config/url.config';



const Login = () => {
  const query = useQuery();
  const dispatch  = useDispatch();
  const userReducer = useSelector((state: RootReducerType) => state.userReducer)
  const [loading, setLoading] = useState(false);
  let {isLogin} = userReducer;
  const onFinish = useCallback((values: { username: string, password: string }) => {
    dispatch(loginRequestAction(values.username, values.password, setLoading));
  }, [dispatch]);
  if(isLogin) {
    let url = query.get('returnUrl');
    return <Navigate to={url !== null ? url: UrlConfig.HOME} replace />
  }
  return (
    <div className={'container-login'}>
      <div className={'login'}>
        <img src={logo} alt="logo" />
        <Form
          className='login-form'
          layout="vertical"
          initialValues={{ username: '', password: '' }}
          onFinish={onFinish}>
          <Form.Item
            className="row-form"
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Username cannot be empty'}, {pattern: /^[a-zA-Z0-9]{4,20}$/, message: "Username is not valid"}]}
          >
            <Input size="large" disabled={loading} placeholder="Username" />
          </Form.Item>

          <Form.Item
             className="row-form"
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Password cannot be empty' }, {min: 6, message: "Password is not valid"}]}
          >
            <Input.Password disabled={loading} size="large" placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button loading={loading}  size="large" type="primary" htmlType="submit" className="login-form-button">
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Login;